import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { GlobalStyle } from '../../components/Layout';
import AnniversaryLogo from '../../components/AnniversaryLogo';
import { mobileWidth } from '../../style';
import anniversaryPhoto from '../../assets/aniversario/foto-20-anos.jpg';

function Home() {
    return (
        <>
            <GlobalStyle />
            <HomeStyled>
                <CompositionStyled>
                    <HeaderStyled>
                        <AnniversaryLogo />
                    </HeaderStyled>
                    <PhotoFrameStyled>
                        <PhotoStyled
                            src={anniversaryPhoto}
                            width="1600"
                            height="1258"
                            alt="Dos personas en la sala de La Usina junto a un cartel de teatro, con motivo del 20 aniversario."
                        />
                    </PhotoFrameStyled>
                </CompositionStyled>
                <LinksStyled aria-label="Descubre La Usina">
                    <HomeLinkStyled to="/sala">Sala</HomeLinkStyled>
                    <HomeLinkStyled to="/escuela">Escuela</HomeLinkStyled>
                </LinksStyled>
            </HomeStyled>
        </>
    );
}

export default Home;

const HomeStyled = styled.main`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: 100vh;
    height: 100svh;
    min-height: 40rem;
    padding-block: clamp(1rem, 2vh, 1.5rem);
    background: #010101;
    color: white;
    font-family: 'Neuropol', sans-serif;

    @media (max-width: 600px) {
        --mobile-composition-shift: clamp(2rem, 10svh, 5rem);
        height: auto;
        min-height: max(40rem, 100svh);
    }
`;

const CompositionStyled = styled.div`
    display: flex;
    flex: 1;
    min-height: 0;
    flex-direction: column;
    align-items: center;

    @media (max-width: 600px) {
        flex: 0 0 auto;
    }
`;

const HeaderStyled = styled.header`
    position: relative;
    z-index: 1;
    flex-shrink: 0;
    width: min(94%, 50rem);

    @media (max-width: 600px) {
        .anniversary {
            transform: translateY(calc(var(--mobile-composition-shift) / 2));
        }
    }
`;

const PhotoFrameStyled = styled.div`
    display: flex;
    flex: 1;
    min-height: 0;
    width: 100%;
    align-items: flex-start;
    justify-content: center;
    margin-top: calc(-1 * clamp(0.75rem, 2vh, 2rem));

    @media (max-width: 600px) {
        flex: 0 0 auto;
        /* Reparte el hueco inferior sin alterar la altura de Sala/Escuela. */
        transform: translateY(var(--mobile-composition-shift));
    }
`;

const PhotoStyled = styled.img`
    display: block;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    mask-image:
        linear-gradient(to right, transparent, black 5%, black 95%, transparent),
        linear-gradient(to bottom, black 88%, transparent);
    mask-composite: intersect;

    @media (min-width: 1119px) {
        /* Prolonga la parte inferior bajo los accesos, dejando el maletín por encima. */
        max-height: 114%;
    }

    @media (max-width: 600px) {
        width: 100%;
        max-height: none;
    }
`;

const LinksStyled = styled.nav`
    position: relative;
    z-index: 1;
    display: flex;
    flex: 0 0 clamp(7rem, 15vh, 10rem);
    justify-content: space-between;
    gap: clamp(1rem, 3vw, 3rem);
    width: 60%;
    margin-inline: auto;

    @media (max-width: ${mobileWidth}) {
        flex-basis: 12rem;
        width: 100%;
        justify-content: flex-end;
        align-items: center;
        flex-direction: column;
        gap: 1rem;
    }

    @media (max-width: 600px) {
        flex: 1 0 12rem;
    }
`;

const HomeLinkStyled = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    min-width: 0;
    border: max(2px, 0.5vw) solid white;
    border-radius: 10px;
    background: transparent;
    color: white;
    font-size: max(1.5rem, 4vw);
    line-height: 1;
    text-decoration: none;
    text-align: center;
    overflow-wrap: anywhere;

    @media (max-width: ${mobileWidth}) {
        flex: 0 0 calc((100% - 1rem) / 4);
        width: 90%;
        font-size: clamp(1.5rem, 3vw, 1.75rem);
    }

    &:hover {
        color: #f46d2b;
        border-color: #f46d2b;
    }

    &:focus-visible {
        outline: 3px solid #f46d2b;
        outline-offset: 5px;
    }
`;
